import { Box, Typography } from '@mui/material'
import * as React from 'react'

type Props = {
	// 長さ24。各時間帯が ON になり得る（有効かつ条件あり）か
	activeByHour: boolean[]
	label?: string
}

// 24時間の ON/OFF 設定状況を帯グラフで俯瞰する。ヒーター/電磁弁 共通。
function HourlyOverviewBand({
	activeByHour,
	label = '設定状況（24時間）',
}: Props) {
	const onCount = activeByHour.filter(Boolean).length

	return (
		<Box sx={{ mb: 1.5 }}>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'baseline',
					mb: 0.5,
				}}
			>
				<Typography variant="caption" color="text.secondary">
					{label}
				</Typography>
				<Typography variant="caption" color="text.secondary">
					ON {onCount} / 24 時間
				</Typography>
			</Box>

			<Box sx={{ overflowX: 'auto' }}>
				<Box sx={{ minWidth: 288 }}>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: 'repeat(24, 1fr)',
							gap: '2px',
						}}
					>
						{activeByHour.map((on, h) => (
							<Box
								key={h}
								title={`${h}時 ${on ? 'ON' : 'OFF'}`}
								sx={{
									height: 22,
									borderRadius: '3px',
									bgcolor: on ? 'success.main' : 'action.disabledBackground',
									opacity: on ? 1 : 0.6,
								}}
							/>
						))}
					</Box>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: 'repeat(24, 1fr)',
							gap: '2px',
							mt: 0.25,
						}}
					>
						{activeByHour.map((_on, h) => (
							<Typography
								key={h}
								variant="caption"
								align="center"
								sx={{
									fontSize: 8,
									lineHeight: 1,
									color: 'text.disabled',
									fontVariantNumeric: 'tabular-nums',
								}}
							>
								{h % 3 === 0 ? h : ''}
							</Typography>
						))}
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default HourlyOverviewBand
